import React from "react";
import { Link } from "react-router-dom";

export const CompanyLogo = () => (
  <section
    className="site-logo"
    style={{
      textAlign: "center",
      padding: "0.25rem",
      backgroundColor: "white",
      color: "white",
      flex: "0 1 30vh",
      flexWrap: "wrap",
      alignItems: "center",
      margin: "0.25rem auto",
      paddingBottom: '1rem',
    }}
  >
    <Link to="/" aria-label="I.T.O. Insurance Agency home">
      <img
        src="/jessica_ito.png"
        alt="I.T.O. Insurance Agency"
        width={614}
        height={150}
        style={{
          width: "min(42rem, 100%)",
          maxWidth: "100%",
          height: "auto",
        }}
      />
    </Link>
  </section>
);
